import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import HomePage from "@/pages/HomePage";
import LessonPage from "@/pages/LessonPage";
import HistoryPage from "@/pages/HistoryPage";
import ProgressPage from "@/pages/ProgressPage";
import ProfilePage from "@/pages/ProfilePage";
import VocabularyPage from "@/pages/VocabularyPage";
import PrintPage from "@/pages/PrintPage";
import TeamPage from "@/pages/TeamPage";
import ImageQuizPage from "@/pages/ImageQuizPage";
import ChefDashboardPage from "@/pages/ChefDashboardPage";
import RecapPage from "@/pages/RecapPage";
import PronunciationPage from "@/pages/PronunciationPage";
import LexiconPage from "@/pages/LexiconPage";
import PhotoIdentifyPage from "@/pages/PhotoIdentifyPage";
import CertificatePage from "@/pages/CertificatePage";
import VerifyCertificatePage from "@/pages/VerifyCertificatePage";
import PosterPage from "@/pages/PosterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import { HardHat } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="app-loading">
        <HardHat className="w-10 h-10 text-orange-500 animate-bounce" />
      </div>
    );
  if (!user) return <Navigate to="/connexion" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/connexion" element={<PublicOnly><AuthPage /></PublicOnly>} />
          <Route path="/mot-de-passe-oublie" element={<PublicOnly><ForgotPasswordPage /></PublicOnly>} />
          <Route path="/reinitialiser" element={<ResetPasswordPage />} />
          <Route path="/verifier" element={<VerifyCertificatePage />} />
          <Route path="/verifier/:code" element={<VerifyCertificatePage />} />
          <Route path="/vocabulaire" element={<Protected><VocabularyPage /></Protected>} />
          <Route path="/imprimer" element={<Protected><PrintPage /></Protected>} />
          <Route path="/equipe" element={<Protected><TeamPage /></Protected>} />
          <Route path="/quiz-images" element={<Protected><ImageQuizPage /></Protected>} />
          <Route path="/equipe/chef" element={<Protected><ChefDashboardPage /></Protected>} />
          <Route path="/prononciation" element={<Protected><PronunciationPage /></Protected>} />
          <Route path="/equipe/lexique" element={<Protected><LexiconPage /></Protected>} />
          <Route path="/photo-outil" element={<Protected><PhotoIdentifyPage /></Protected>} />
          <Route path="/certificat/:id" element={<Protected><CertificatePage /></Protected>} />
          <Route path="/affiche" element={<Protected><PosterPage /></Protected>} />
          <Route path="/bilan" element={<Protected><RecapPage /></Protected>} />
          <Route path="/" element={<Protected><HomePage /></Protected>} />
          <Route path="/lecon/:id" element={<Protected><LessonPage /></Protected>} />
          <Route path="/lecons" element={<Protected><HistoryPage /></Protected>} />
          <Route path="/progression" element={<Protected><ProgressPage /></Protected>} />
          <Route path="/profil" element={<Protected><ProfilePage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
